export default "__VITE_ASSET__DAOFn_Hv__"